import gql from 'graphql-tag';

export const allCarriers = gql`
  query allCarriers {
    allCarriers {
      nodes {
        id
        truck
        trailer
        type
        driver1Tel
        driver2Tel
        emptyWeight
        trolleysSection1
        trolleysSection2
        storagesByCarrierId {
          nodes {
            id
            fileName
            fileSize
            fileType
            url
          }
        }
      }
    }
  }
`;

export const createCarrier = gql`
  mutation(
    $truck: String
    $trailer: String
    $type: String
    $driver1Tel: String
    $driver2Tel: String
    $emptyWeight: String
    $trolleysSection1: Int
    $trolleysSection2: Int
    $about: String
  ) {
    createCarrier(
      input: {
        carrier: {
          truck: $truck
          trailer: $trailer
          type: $type
          driver1Tel: $driver1Tel
          driver2Tel: $driver2Tel
          emptyWeight: $emptyWeight
          trolleysSection1: $trolleysSection1
          trolleysSection2: $trolleysSection2
          about: $about
        }
      }
    ) {
      carrier {
        id
      }
    }
  }
`;

export const updateCarrierById = gql`
  mutation(
    $id: Int!
    $selected: Boolean
    $truck: String
    $trailer: String
    $type: String
    $driver1Tel: String
    $driver2Tel: String
    $emptyWeight: String
    $trolleysSection1: Int
    $trolleysSection2: Int
    $about: String
  ) {
    updateCarrierById(
      input: {
        id: $id
        carrierPatch: {
          selected: $selected
          truck: $truck
          trailer: $trailer
          type: $type
          driver1Tel: $driver1Tel
          driver2Tel: $driver2Tel
          emptyWeight: $emptyWeight
          trolleysSection1: $trolleysSection1
          trolleysSection2: $trolleysSection2
          about: $about
        }
      }
    ) {
      carrier {
        id
      }
    }
  }
`;

export const deleteCarrierById = gql`
  mutation deleteCarrierById($id: Int!) {
    deleteCarrierById(input: { id: $id }) {
      deletedCarrierId
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/carriers.js